import { render, staticRenderFns } from "./practicalWantingList.vue?vue&type=template&id=0d2f3d97&scoped=true&"
import script from "./practicalWantingList.vue?vue&type=script&lang=js&"
export * from "./practicalWantingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2f3d97",
  null
  
)

export default component.exports